module.exports = __webpack_public_path__ + "files/6c3f37a0ed8194666619243575ed2fd1.png";